import { fixSupabasePublicStorageUrl, normalizeSupabaseProjectUrl } from "./supabaseUrl";

/** Profile uploads use base64url object keys; DB values retain the original path. */
export function getProfileAvatarUrl(
  path: string | null | undefined,
  projectUrl: string,
): string {
  const value = path?.trim();
  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return fixSupabasePublicStorageUrl(value);

  const clean = value.replace(/^\/(?:media\/)?/, "");
  if (!clean) return "";
  const bytes = new TextEncoder().encode(clean);
  let binary = "";
  for (const byte of bytes) binary += String.fromCharCode(byte);
  const key = btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  return `${normalizeSupabaseProjectUrl(projectUrl)}/storage/v1/object/public/foreducator-media/${key}`;
}
